import { LibraryDeleteConfirmDialog } from '@/features/library/components/LibraryDeleteConfirmDialog'

type Props = Readonly<{
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  isPending?: boolean
}>

export function QuestionBankRemoveDialog({
  open,
  onCancel,
  onConfirm,
  isPending = false,
}: Props) {
  return (
    <LibraryDeleteConfirmDialog
      open={open}
      title="Remove this question from the Question Bank?"
      onCancel={onCancel}
      onConfirm={onConfirm}
      isPending={isPending}
      dialogTestId="question-bank-remove-dialog"
      cancelTestId="question-bank-remove-cancel"
      confirmTestId="question-bank-remove-confirm"
    />
  )
}
